import {Button} from 'antd';
import React from 'react';
import ReFulfillAdditionaDataRow from './RefulfillAdditionalDataRow';
import {
  REDEEM_CLAIMED_OFFER_TYPE,
  REFULFILL_CLAIMED_OFFER_TYPE,
} from 'Utils/constants/genericConstants';
import RedeemAdditionaDataRow from './RedeemAdditionalDataRow';

interface NestedRowContainerProps {
  row: any;
  backgroundColor: string;
  onReFulfillClick: (ClaimedOfferAdditionalData, string, boolean) => void;
  isOpen?: boolean;
}

const getAddressJSX = (row: any) => {
  return row.type === 'Plastic' ? (
    <span>
      {row.additionalData?.sentToAddress?.line1 && <p>{row.additionalData.sentToAddress?.line1}</p>}
      {row.additionalData?.sentToAddress?.line2 && <p>{row.additionalData.sentToAddress?.line2}</p>}
      <p>
        {row.additionalData?.sentToAddress?.city},&nbsp;
        {row.additionalData?.sentToAddress?.region},&nbsp;
        {row.additionalData?.sentToAddress?.postalCode}
      </p>
    </span>
  ) : undefined;
};

const NestedRowContainer = (props: NestedRowContainerProps) => {
  const isRedeemOrderType = props.row.orderType === REDEEM_CLAIMED_OFFER_TYPE;

  const isRedeemSpecialCase = isRedeemOrderType && props.row.additionalDataSecondRow;

  const isReFullfillOrderType = props.row.orderType === REFULFILL_CLAIMED_OFFER_TYPE;

  const isReFullfillSpecialCase = isReFullfillOrderType && props.row.additionalDataSecondRow;

  const getButtonJSX = (isSecondRow: boolean, data: any) => {
    if (
      (!isSecondRow &&
        !props.row.buttonDetails.isSpecialCase &&
        props.row.buttonDetails?.visible) ||
      (isSecondRow && props.row.buttonDetails?.visible)
    ) {
      return (
        <Button
          type="primary"
          onClick={() => {
            props.onReFulfillClick(
              data,
              props.row.buttonDetails?.type,
              props.row?.buttonDetails?.isSpecialCase,
            );
          }}
          style={{fontWeight: 800, minWidth: 170, padding: 8}}>
          {props.row.buttonDetails?.type}
        </Button>
      );
    }
    return;
  };

  if (props.row.additionalData) {
    // Note: the original animated this open/close with MUI's <Collapse>;
    // this is a plain conditional render (unmounts when closed, matching
    // unmountOnExit) without the height-transition animation.
    return (
      <tr style={{background: props.backgroundColor}}>
        <td
          style={{
            paddingBottom: props.isOpen ? undefined : 0,
            paddingTop: props.isOpen ? undefined : 0,
          }}
          colSpan={11}>
          {props.isOpen && (
            <div style={{marginLeft: 14, margin: 8}}>
              {isRedeemOrderType && (
                <RedeemAdditionaDataRow
                  data={props.row.additionalData}
                  sentToAddressMarkUp={getAddressJSX(props.row)}
                  buttonJSX={getButtonJSX(
                    false,
                    props.row.additionalData,
                  )}></RedeemAdditionaDataRow>
              )}

              {isRedeemSpecialCase && (
                <ReFulfillAdditionaDataRow
                  data={props.row.additionalDataSecondRow!}
                  buttonJSX={getButtonJSX(true, props.row.additionalDataSecondRow!)}
                  isSecondRow={true}></ReFulfillAdditionaDataRow>
              )}

              {isReFullfillOrderType && (
                <ReFulfillAdditionaDataRow
                  data={props.row.additionalData}
                  sentToAddressMarkUp={getAddressJSX(props.row)}
                  buttonJSX={getButtonJSX(
                    false,
                    props.row.additionalData,
                  )}></ReFulfillAdditionaDataRow>
              )}

              {isReFullfillSpecialCase && (
                <ReFulfillAdditionaDataRow
                  data={props.row.additionalDataSecondRow!}
                  buttonJSX={getButtonJSX(true, props.row.additionalDataSecondRow!)}
                  isSecondRow={true}></ReFulfillAdditionaDataRow>
              )}
            </div>
          )}
        </td>
      </tr>
    );
  }
  return null;
};

export default NestedRowContainer;
